module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-42.ba1af77.woff2";